






















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import Responsavel from '@/model/resource/Responsavel'
import {success, ID} from 'simpli-web-sdk'
import {Action} from 'vuex-class'

@Component
export default class ModalAuditAutomaticNotification extends Vue {
  @Prop({type: Responsavel, required: true}) responsavel!: Responsavel
  @Action('auth/auth') auth!: Function

  isDisabled = false
  dias: number | null = null

  close() {
    this.$modal.close('auditAutomaticNotification')
  }

  openEvent() {
    this.$emit('open')
    this.dias = this.responsavel.diasNotificacaoAutomaticaAuditoria
  }

  closeEvent() {
    this.$emit('close')
  }

  get isButtonDisabled() {
    return this.isDisabled
  }

  async persistAuditAutomaticNotification() {
    this.$await.init('updateAuditAutomaticNotification')
    this.isDisabled = true
    if (!this.responsavel) {
      return
    }
    this.responsavel.diasNotificacaoAutomaticaAuditoria = this.dias
    await this.responsavel.persistDiasNotificacaoAutomatica(this.responsavel)
    await this.auth
    this.$await.done('updateAuditAutomaticNotification')
    success('system.success.persist')
    await this.close()
    this.isDisabled = false
  }

  getButtonClass() {
    return this.isDisabled ? 'disabled-button' : 'primary'
  }
}
